// Lightweight image URL optimizer: shrinks + webp-converts images at the source.
// Works for our own object-storage media (/api/media/...) and Unsplash/Pexels stock URLs.
export function img(url, width = 600) {
  if (!url || typeof url !== "string") return url;
  const w = Math.round(width);

  // Our media proxy supports ?w= & fmt=webp (backend resizes on the fly)
  if (url.startsWith("/api/media/") || url.includes("/api/media/")) {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}w=${w}&fmt=webp`;
  }

  // Unsplash (imgix) — force width, webp, sensible quality
  if (url.includes("images.unsplash.com")) {
    try {
      const u = new URL(url);
      u.searchParams.set("w", String(w));
      u.searchParams.set("q", "72");
      u.searchParams.set("auto", "format");
      u.searchParams.set("fit", "crop");
      u.searchParams.delete("fm");
      return u.toString();
    } catch { return url; }
  }

  // Pexels — width + auto compress
  if (url.includes("images.pexels.com")) {
    try {
      const u = new URL(url);
      u.searchParams.set("w", String(w));
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.delete("h");
      u.searchParams.delete("dpr");
      return u.toString();
    } catch { return url; }
  }

  return url;
}

// Build a responsive srcset string (multiple widths) for the same source.
export function imgSrcSet(url, widths = [400, 600, 800, 1200]) {
  if (!url || typeof url !== "string") return undefined;
  const optimizable = url.includes("/api/media/") || url.includes("images.unsplash.com") || url.includes("images.pexels.com");
  if (!optimizable) return undefined;
  return widths.map((w) => `${img(url, w)} ${w}w`).join(", ");
}
